import { useCurrentOrderAddItemsMutationWithContext } from '@reliv/redux-global-cart';
import noop from 'lodash/noop';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectView } from '../../slices/view';
import { ViewID } from '../../types';
import CloseButton from '../shared/CloseButton';
import Errors from '../shared/Errors';
import LoadingSpinner from '../shared/LoadingSpinner';
import t from '@rcm/i18n-client';

const AddToCartStatus = () => {
    const view = useSelector(selectView);
    const [, currentOrderAddItems] = useCurrentOrderAddItemsMutationWithContext();

    return <Modal show={view === ViewID.ADD_TO_CART_STATUS} onHide={noop}>
        <Modal.Body>{
            currentOrderAddItems.isLoading ?
                <LoadingSpinner text={t("Adding items to your cart...")} /> :
            currentOrderAddItems.isSuccess ?
                <LoadingSpinner text={t("Redirecting to your cart...")} /> :
            currentOrderAddItems.isError ?
                <Errors error={currentOrderAddItems.error} /> :
            ''
        }</Modal.Body>
        <Modal.Footer>
            <CloseButton
                disabled={(
                    currentOrderAddItems.isLoading ||
                    currentOrderAddItems.isSuccess
                )}
            />
        </Modal.Footer>
    </Modal>;
}

export default AddToCartStatus;
